module.exports = __webpack_public_path__ + "static/hit-men-9e15054f9b769d3a70e8bac4168eb959.jpg";